import React, { Component } from 'react'
import '../../css/Loading.css'

const _package = require('../../../package.json')

const LoadingContent = props => (
	<div id="loading-wrapper">
		<div className="loader">
			<div className="loading-async">
				<span className="loading-modern" />
				<h5 className="fade-swift">
					Yuanta Advisory Agent
					<br />
					{_package.version}
				</h5>
			</div>
		</div>
	</div>
)

function LoadingComponent(props) {
	if (props.error) {
		// When the loader has errored
		return (
			<div>
				Error! <button onClick={props.retry}>Retry</button>
			</div>
		)
	} else if (props.timedOut) {
		// When the loader has taken longer than the timeout
		return (
			<div>
				Taking a long time... <button onClick={props.retry}>Retry</button>
			</div>
		)
	} else if (props.pastDelay) {
		// When the loader has taken longer than the delay
		return <LoadingContent />
	} else {
		// When the loader has just started
		return <LoadingContent />
	}
}

export default LoadingComponent
